import { render } from "./fullcoloredPage.vue?vue&type=template&id=73803da5"
import script from "./fullcoloredPage.vue?vue&type=script&lang=js"
export * from "./fullcoloredPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__